import { render, staticRenderFns } from "./addToWLBLItem.vue?vue&type=template&id=bf3e4ce2&"
import script from "./addToWLBLItem.vue?vue&type=script&lang=js&"
export * from "./addToWLBLItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports